import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useMedia } from 'react-media';
import { Typography, Link, CircularProgress } from '@material-ui/core';
import TopBar from "./TopBar";
import LeftBar from "./LeftBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Snackbar from '@material-ui/core/Snackbar';
import MainContent from "./MainContent";
import Cookie from "./Cookie";
import Contacts from "./Contacts";
import About from "./About";
import AppListRouter from "./Applications/AppListRouter";
import ProdListRouter from "./Products/ProdListRouter";
import SolutionListRouter from "./Solutions/SolutionListRouter";
import CloudListRouter from "./Cloud/CloudListRouter";
import PageNotFound from "./Errors/PageNotFound";
import BasketContent from "./Basket/BasketContent";
import SearchContent from "./SearchContent";
import PrimaryButton from './PrimaryButton';
import FavoritesContent from './Favorites/FavoritesContent'
import Interview from './Interview'
import Grid from "@material-ui/core/Grid";
import axios from 'axios';
import Container from '@material-ui/core/Container';
import clsx from "clsx";
import Footer from "./Footer";
import AppCard from './Applications/AppCard';
import config from '../other/config';
import PartnersListRouter from './Partners/PartnersListRouter';
import IconButton from '@material-ui/core/IconButton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SnackbarCookies from './SnackbarCookies';

import utils from '../other/utils';


const { serverAPI } = config;

const drawerWidth = 334;

function union(setA) {
	let unionArr = []
	setA.forEach(el => {
		if (unionArr.includes(el)) {

		} else {
			unionArr.push(+el)
		}
	})
	return unionArr
}

const getItemFromStorage = (item, defaultValue = []) => {
	try {
		return JSON.parse(localStorage.getItem(item)) || defaultValue
	} catch (e) {
		return defaultValue
	}
}

export default function Main({ isMetrikaActive, setMetrikaActive }) {
	const classes = useStyles();
	const language = localStorage.getItem('language') || 'Ru'
	const [inCu, _inCu] = useState(localStorage.getItem('inCu') || '1')
	const [open, setOpen] = useState(document.documentElement.clientWidth < 1366 ? false : true);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [expanded, setExpanded] = useState(0);
	const listNum = 0;
	const [bank, setBank] = useState('');
	const [menuAppsRenderNew, setMenuAppsRenderNew] = useState([]); /**Возможно стоит собрать всё меню в один запрос */
	const [appBasket, _appBasket] = useState(getItemFromStorage('cartApp'));
	const [cloudBasket, _cloudBasket] = useState(getItemFromStorage('cartCloud'));
	const [productBasket, _productBasket] = useState(getItemFromStorage('cartProd'));
	const [appFavorite, _appFavorite] = useState(getItemFromStorage('favoriteApp'));
	const [productFavorite, _productFavorite] = useState(getItemFromStorage('favoriteProduct'));
	const [appFavoriteInProduct, _appFavoriteInProduct] = useState(getItemFromStorage('favoriteAppInProduct'));
	const [appCartInProduct, _appCartInProduct] = useState(getItemFromStorage('cartAppInProduct'));
	const [appsInProductFavorite, _appsInProductFavorite] = useState([]);
	const [appsInProductCart, _appsInProductCart] = useState([]);
	const [CatalogCu, _CatalogCu] = useState(undefined);
	const [searchAction, setSearchAction] = useState(true);
	const [searchText, setSearchText] = useState('');
	const [findText, setFindText] = useState('');
	const [isAuth, setIsAuth] = React.useState(false);
	const [usname, setUsname] = useState(null);
	const [basketChips, setBasketChips] = useState('')
	const [menu, setMenuItems] = useState([])
	const [isErr, _isErr] = useState(false);
	const [catalog, setCatalog] = useState({});
	const [openSnackbar, _openSnackbar] = React.useState(false);
	const [openSnackbarCookies, _openSnackbarCookies] = React.useState(false);
	const [altCookieSnackbar, _altCookieSnackbar] = useState(false);
	const [snackbarMessage, _snackbarMessage] = useState(null);
	const [showPagination, _showPagination] = useState(true);
	const [visible, setVisible] = useState(false)
	const [showInterview, _showInterview] = useState(false)
	const [kloUser, _kloUser] = useState({})
	const [kloBanks, _kloBanks] = useState([])
	const [isSynchronnyLoading, _isSynchronnyLoading] = useState(false);
	const [testID, _testID] = useState(false);
	const [searchPhrases, _searchPhrases] = useState([]);
	const [cookiesUID, _cookiesUID] = useState('');
	const [cookies1, _cookies1] = useState('block');
	const [cookies2, _cookies2] = useState('none');
	const [cookiesAnalitycs, _cookiesAnalitycs] = useState(false);
	const cookieMessage = language === 'Ru'
		?
		<Typography variant="p" className={classes.pCookie}>
			Мы используем cookies, чтобы запомнить ваши настройки, анализировать работу сайта, в том числе с помощью метрических программ, и повышать его эффективность. Перед тем, как Вы продолжите пользоваться сайтом, пожалуйста, ознакомьтесь с нашей <a href="https://www.cft.ru/sites/cft/Documents/Politics.pdf" className={classes.LinkType11}>Политикой конфиденциальности</a>, особенно с разделом о cookies. Вам предоставлена возможность согласиться или отказаться от ВСЕХ cookies, а также выбрать предпочитаемые cookies в разделе «Настройки cookies».
		</Typography>
		:
		<Typography variant="p" className={classes.pCookie}>
			We use cookies to remember your settings, analyze website performance, including using analytics programs, and improve its effectiveness. Before continuing to use the website, please read our <a href="https://www.cft.ru/sites/cft/Documents/Politics.pdf" className={classes.LinkType11}>Privacy Policy</a>, specifically the section on cookies. You can accept or decline ALL cookies, as well as select your preferred cookies in the "Cookie Settings" section.
		</Typography>

	const LANG = language //=== 'Ru' ? 'En' : 'Ru'

	window.onload = scrollMenu

	const handleEnableMetrika = (cookiesAnalitycs) => {
		if (window.location.href.indexOf('catalog.cft.ru') > -1 && cookiesAnalitycs) {
			console.log("Метрика будет включена через 2 секунды...");

			setTimeout(() => {
				setMetrikaActive(true);
				console.log("Метрика инициализирована");
			}, 2000);
		} else {
			console.warn("Домен не совпадает, метрика не будет запущена");
		}
	};

	const getAgreements = async (needCallApiWOUID = false) => {
		if (needCallApiWOUID || cookiesUID !== '') {
			let agreements = await axios.get(`${serverAPI}/api/getAgreements?uid=${cookiesUID}`);
					let appsInProductFavorite_ = [];
					let appsInProductCart_ = [];

					if (agreements && agreements.data) {
						if (agreements.data.cookiesAgreements?.length > 0) {
							_cookiesAnalitycs(agreements.data.cookiesAgreements?.[0]?.Analitycs)

							if (agreements.data.cookiesAgreements[0].Analitycs === 1) {
								handleEnableMetrika(agreements.data.cookiesAgreements[0].Analitycs === 1);
							}
							_openSnackbarCookies(agreements.data.needShowMessage);
						} else {
							_openSnackbarCookies(agreements.data.needShowMessage);
						}
					} else {
						_openSnackbarCookies(true);
					}

					appFavoriteInProduct.map(el => { appsInProductFavorite_ = appsInProductFavorite_.concat(el.apps); })
					_appsInProductFavorite(appsInProductFavorite_)

					appCartInProduct.map(el => { appsInProductCart_ = appsInProductCart_.concat(el.apps) })
					_appsInProductCart(appsInProductCart_)
		}
	} 

	// ===== Проверка Cookies ===============
	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			if (!didCancel) {
				getAgreements()
			}
		}
		fetchData();

	}, [cookiesUID])
	// =============== Проверка Cookies =====

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {


			if (!didCancel) {
				window.addEventListener('scroll', toggleVisible);
				window.addEventListener('resize', toggleVisible);
				try {
					// let user = sessionStorage.getItem('user')
					// if (se)
					//console.log(window.location)
					let user = await axios.get(`${utils.getKLOLink()}/user?${new Date().getMilliseconds()}`,
						{
							withCredentials: true,
							headers: {
								"Access-Control-Allow-Origin": window.location.origin,
								'Cache-Control': 'cache',
								'Pragma': 'cache',
								'Expires': '0',
							}
						});
					//console.log(user && user.data && user.data.result !=="notAuthorized" )
					if (user && user.data && user.data.result !== "notAuthorized" && (
						(user.data.IS_BANK === '1' && (user.data.KLO_USERS_BANKS === '1' || user.data.READ_ONLY === '1' || user.data.KLO_EDO_BANK === '1')) ||
						(user.data.IS_CFT === '1' && (user.data.KLO_USER === '1' || user.data.CI_SUPPORT === '1' || user.data.CI_SUPPORT_DIRECTOR === '1')))) {
						console.log(user.data.IS_BANK === '1' && (user.data.KLO_USERS_BANKS === '1' || user.data.READ_ONLY === '1' || user.data.KLO_EDO_BANK === '1'))
						//_kloUser(user.data);
						let hasFeedback = false;
						/*if (sessionStorage.getItem('hasFeedback') !== null) {
							hasFeedback = sessionStorage.getItem('hasFeedback') === '1';
						} else {
							let hasKLOFeedback = await axios.post(`${serverAPI}/getKLORrewiew`, {ci_mkt_id:user.data.CI_MKT_USERS_ID});
							if (hasKLOFeedback && hasKLOFeedback.data && hasKLOFeedback.data.hasKLOFeedBack !== undefined) {
								hasFeedback = hasKLOFeedback.data.hasKLOFeedBack == true;
								sessionStorage.setItem('hasFeedback', hasFeedback ? '1' : '0');
							}
						}*/
						let cftBanks = []
						if (sessionStorage.getItem('kloBanks') !== null) {
							cftBanks = JSON.parse(sessionStorage.getItem('kloBanks'))
						} else {
							let banks = await axios.get(`${utils.getKLOLink()}/getBanksList?${new Date().getMilliseconds()}`,
								{
									withCredentials: true,
									headers: {
										"Access-Control-Allow-Origin": window.location.origin,
										'Cache-Control': 'cache',
										'Pragma': 'cache',
										'Expires': '0',
									}
								});

							if (banks && banks.data.items && banks.data.items.length > 0) {

								banks.data.items.filter(el => el.KLO_ACTIVE === '1').map(bank => {
									bank.SYSTEM = bank.SYSTEM.filter(el => el.CODE === "CFT_BANK_2MCA")
									if (bank.SYSTEM.length > 0) {
										let kloBank = { name: bank.NAME, serverParts: bank.SYSTEM[0].SERVER_PART.map(el => { return { code: el.SERVER_PART_CODE, id: el.ID, serverID: el.SERVER_PART_ID, name: el.SERVER_PART_NAME } }) }
										cftBanks.push(kloBank)

									}
								})
								console.log(banks.data.items.length, cftBanks.length)

								sessionStorage.setItem('kloBanks', JSON.stringify(cftBanks))

							}


						}
						let currentBank = {}//user.data.CURRENT_SERVER_PART
						let currentServerPart = localStorage.getItem('currentBank') === null ? user.data.CURRENT_SERVER_PART : localStorage.getItem('currentBank');
						cftBanks.map(bank => {
							bank.serverParts.map(server => {

								if (server.id === currentServerPart) {
									currentBank = bank
								}
							})
						})
						_kloUser({ user: user.data, hasFeedback, banks: cftBanks, currentBank, currentServerPart, showBankSelect: utils.getStringFromStorage('showBank') === '0' ? false : true })
					}

				} catch (e) {
					console.log(e)
				}
				const login = await axios.get(`${serverAPI}/auth`).catch(e => { getAgreements(true)});
				if (login && login.data && login.data.error === undefined) {
					setUsname(login.data)
					fnv1aHash(login.data.email)
					// setUsname({usname:'Nfhffh', 
					// organization: 'fssdf', 
					// email: '1@cft.ru',
					// title: 'sdf',
					// phone: "45545456"
					// })
					setIsAuth(true)
					if (utils.getStringFromStorage('tryLogOut') === '1') {
						try {
							localStorage.removeItem('tryLogOut');
						} catch (e) {

						}

					}
					getUserCollections()

				} 
				if (login && login.data && login.data.canAuth === true) {
					let { href } = window.location;
					if (utils.getStringFromStorage('tryLogOut') !== '1') {
						utils.setDataToStorage('tryLogOut', '1');
						window.location.href = '/login?linkTo=' + href
					}

				}

			}
		}

		fetchData();
		//const link = document.getElementById('login-js')

		// var element = document.createElement('button');
		// element.style.display = 'none';
		// element.id = 'login-js'
		// element.onclick = fetchData//.bind(this)

		// document.getElementById('drawerOpenScroll').appendChild(element)
		// const link = document.getElementById('login-js')

		// if (link !== null) {
		// 	console.log("click")
		// 	link.click()
		// 	link.remove()
		// }

		return () => {
			didCancel = true;
		};
	}, []);

	function handleClick() {
		setFindText(searchText)
		setSearchAction(!searchAction)
	}

	const getUniqArr = (arr, prop) => {
		let uniqueArr = [];
		arr.map(el => { if ((prop === undefined && !uniqueArr.includes(el)) || (prop !== undefined && !uniqueArr.map(elem => elem[prop]).includes(el[prop]))) { uniqueArr.push(el) } });
		return uniqueArr
	}

	const showTestId = () => {
		_testID(true);
	}

	const getUserCollections = async () => {
		if (sessionStorage.getItem('updateCollections') === null) {
			const userCollections = await axios.get(`${serverAPI}/getUserCollections`);
			if (userCollections && userCollections.data && Array.isArray(userCollections.data.appBasket)) {
				let appFavorite_ = getUniqArr(userCollections.data.appFavorite.concat(appFavorite)),
					appBasket_ = getUniqArr(userCollections.data.appBasket.concat(appBasket)),
					productBasket_ = getUniqArr(userCollections.data.productBasket.concat(productBasket)),
					productFavorite_ = getUniqArr(userCollections.data.productFavorite.concat(productFavorite)),
					appFavoriteInProduct_ = getUniqArr(userCollections.data.appFavoriteInProduct.concat(appFavoriteInProduct), 'id'),
					appCartInProduct_ = getUniqArr(userCollections.data.appCartInProduct.concat(appCartInProduct), 'id');
				_appFavorite(appFavorite_);
				localStorage.setItem('favoriteApp', JSON.stringify(appFavorite_));
				_appBasket(appBasket_)
				localStorage.setItem('cartApp', JSON.stringify(appBasket_));
				_productFavorite(productFavorite_);
				localStorage.setItem('favoriteProduct', JSON.stringify(productFavorite_));
				localStorage.setItem('cartProd', JSON.stringify(productBasket_));
				_productBasket(productBasket_);
				_appFavoriteInProduct(appFavoriteInProduct_);
				localStorage.setItem('favoriteAppInProduct', JSON.stringify(appFavoriteInProduct_));
				let appsInProductFavorite_ = [];
				appFavoriteInProduct_.map(el => { appsInProductFavorite_ = appsInProductFavorite_.concat(el.apps); });
				_appsInProductFavorite(appsInProductFavorite_);
				localStorage.setItem('cartAppInProduct', JSON.stringify(appCartInProduct_));
				let appsInProductCart_ = [];
				appCartInProduct_.map(el => { appsInProductCart_ = appsInProductCart_.concat(el.apps) });
				_appsInProductCart(appsInProductCart_);
				sessionStorage.setItem('updateCollections', '1')
			}
		}
	}

	const saveCollection = async (item, type, place, appsInProducts = [], isAddingDependApps = false) => {
		let appFavorite_ = [].concat(appFavorite), appBasket_ = [].concat(appBasket), productBasket_ = [].concat(productBasket), productFavorite_ = [].concat(productFavorite), appFavoriteInProduct_ = [].concat(appFavoriteInProduct), appCartInProduct_ = [].concat(appCartInProduct);
		console.log("saveCollection", item, type, place, appsInProducts)
		if (type === 'clear') {
			if (place === 'favorite') {
				_productFavorite([]);
				_appFavorite([]);
				_appFavoriteInProduct([]);
				productFavorite_ = [];
				appFavorite_ = [];
				appFavoriteInProduct_ = [];
				localStorage.removeItem('favoriteAppInProduct');
				localStorage.removeItem('favoriteApp');
				localStorage.removeItem('favoriteProduct');
				_appsInProductFavorite([]);
			} else {
				_productBasket([]);
				_appBasket([]);
				_appCartInProduct([]);  
				productBasket_ = [];
				appBasket_ = [];
				appCartInProduct_ = [];
				localStorage.removeItem('cartAppInProduct');
				localStorage.removeItem('cartApp');
				localStorage.removeItem('cartProd');
				_appsInProductCart([]);
			}

		} else {
			if (type === 'app' && place === 'favorite') {
				appFavorite_ = appFavorite.includes(item) ? appFavorite.filter(el => el !== item) : appFavorite.concat(item);
				_appFavorite(appFavorite_);
				localStorage.setItem('favoriteApp', JSON.stringify(appFavorite_));
			} else if (type === 'app' && place === 'cart') {
				if (Array.isArray(item) && isAddingDependApps) {
					appBasket_ = item;
				} else {
					appBasket_ = appBasket.includes(item) ? appBasket.filter(el => el !== item) : appBasket.concat(item);
				}
				//appBasket_ = appBasket.includes(item) ? appBasket.filter(el => el !== item) : appBasket.concat(item);
				_appBasket(appBasket_)
				localStorage.setItem('cartApp', JSON.stringify(appBasket_));
			} else if (type === 'product' && place === 'favorite') {
				let isDel = productFavorite.includes(item);
				productFavorite_ = isDel ? productFavorite.filter(el => el !== item) : productFavorite.concat(item);
				_productFavorite(productFavorite_)
				localStorage.setItem('favoriteProduct', JSON.stringify(productFavorite_));
				appFavoriteInProduct_ = isDel ? appFavoriteInProduct.filter(el => el.id !== item) : appFavoriteInProduct.concat({ id: item, apps: appsInProducts })
				_appFavoriteInProduct(appFavoriteInProduct_);
				//console.log('saveCollection1', isDel,appFavoriteInProduct )
				localStorage.setItem('favoriteAppInProduct', JSON.stringify(appFavoriteInProduct_));
				let appsInProductFavorite_ = [];
				appFavoriteInProduct_.map(el => { appsInProductFavorite_ = appsInProductFavorite_.concat(el.apps); });
				_appsInProductFavorite(appsInProductFavorite_);
			}
			else if (type === 'product' && place === 'cart') {
				if (Array.isArray(item) && isAddingDependApps) {
					productBasket_ = productBasket.concat(item.map(el => el.id));
					let appCartInProduct_ = appCartInProduct.concat(item);
					_appCartInProduct(appCartInProduct_);
					localStorage.setItem('cartAppInProduct', JSON.stringify(appCartInProduct_));
					let appsInProductCart_ = [];
					appCartInProduct_.map(el => { appsInProductCart_ = appsInProductCart_.concat(el.apps) });
					_appsInProductCart(appsInProductCart_);

				} else {
					let isDel = productBasket.includes(item);
					productBasket_ = isDel ? productBasket.filter(el => el !== item) : productBasket.concat(item);

					let appCartInProduct_ = isDel ? appCartInProduct.filter(el => el.id !== item) : appCartInProduct.concat({ id: item, apps: appsInProducts });
					_appCartInProduct(appCartInProduct_);
					localStorage.setItem('cartAppInProduct', JSON.stringify(appCartInProduct_));
					let appsInProductCart_ = [];
					appCartInProduct_.map(el => { appsInProductCart_ = appsInProductCart_.concat(el.apps) });
					_appsInProductCart(appsInProductCart_);

				}
				localStorage.setItem('cartProd', JSON.stringify(productBasket_));
				_productBasket(productBasket_)

			}
			//console.log("appBasket:", appBasket_, "productBasket: ",productBasket_, "appFavorite: ",appFavorite_, "productFavorite: ",productFavorite_,"appFavoriteInProduct: ",appFavoriteInProduct_,"appCartInProduct: ",appCartInProduct_)
		}

		if (isAuth) {
			await axios.post(`${serverAPI}/saveUserCollection`, { appBasket: appBasket_, productBasket: productBasket_, appFavorite: appFavorite_, productFavorite: productFavorite_, appFavoriteInProduct: appFavoriteInProduct_, appCartInProduct: appCartInProduct_ });
		}
		return new Promise((resolve) => {
			resolve(1)
		})
	}

	/*
		const [appBasket, _appBasket] = useState(getItemFromStorage('cartApp'))
	const [cloudBasket, _cloudBasket] = useState(getItemFromStorage('cartCloud'))
	const [productBasket, _productBasket] = useState(getItemFromStorage('cartProd'))
	const [appFavorite, _appFavorite] = useState(getItemFromStorage('favoriteApp'))
	const [productFavorite, _productFavorite] = useState(getItemFromStorage('favoriteProduct'))
	const [appFavoriteInProduct, _appFavoriteInProduct] = useState(getItemFromStorage('favoriteAppInProduct'), {apps:[],product:[]})
	const [appCartInProduct, _appCartInProduct] = useState(getItemFromStorage('cartAppInProduct'), {apps:[],product:[]})
	*/

	const view = localStorage.getItem('view') || 'table'

	function setAppBasket(app) {

		let AppBasketStorage = getItemFromStorage('cartApp')

		if (AppBasketStorage.some((element) => element === app.ID) === true) {
			_appBasket(AppBasketStorage.filter(el_ => el_ !== app.ID))
		} else {
			_appBasket(AppBasketStorage.concat([app.ID]))
		}
	}

	function setBasketCloud(apps, IDCloud) {
		let appBasketNew = JSON.parse(localStorage.getItem('cartApp')) || []
		if (cloudBasket.some((element) => element === IDCloud) === true) {
			_cloudBasket(cloudBasket.filter(el_ => el_ !== IDCloud))
			let arr_ = []
			appBasketNew.forEach(el => {
				if (apps.join('#').includes(el)) { } else {
					arr_.push(el)
				}
			})
			_appBasket(arr_)
		} else {
			_cloudBasket(cloudBasket.concat([IDCloud]))
			_appBasket(union(appBasketNew.concat(apps)))

		}
	}

	function getKloStatuses(apps) {
		return new Promise(async (resolve, reject) => {
			let statusObj = {}
			if (kloUser && kloUser.user && kloUser.user.IS_BANK && (kloUser.currentServerPart !== undefined || localStorage.getItem('currentBank') !== null)) {
				const statuses = await axios.post(`${utils.getKLOLink()}/get_lk_apps?month=${utils.getKLOMonth()}&bank=${kloUser.currentServerPart || localStorage.getItem('currentBank')}`,
					{
						apps
					},
					{
						withCredentials: true,
						headers: {
							"Access-Control-Allow-Origin": "https://catalog.cft.ru/",
							'Cache-Control': 'cache',
							'Pragma': 'cache',
							'Expires': '0',
						}
					}).catch((e) => { console.log("getStatusesError", e); resolve({}) });

				if (statuses && statuses.data && Array.isArray(statuses.data.items)) {

					statuses.data.items.map(item => {
						item.OPTIONS.map(app => {
							let status = ''
							if (app.STATUS === "1" && false) {
								status = app.STATUS_NAME
							} else if ("КУПЛЕНО" === app.DOGOVOR_VALUE) {
								status = kloUser && kloUser.user && kloUser.user.IS_BANK === '0' ? `${app.DOGOVOR_VALUE} (${app.USAGE})` : app.DOGOVOR_VALUE;
							} else if (app.DOGOVOR_VALUE === "НЕ КУПЛЕНО") {
								status = `${app.DOGOVOR_VALUE} (${app.USAGE})`
							}
							statusObj[app.CODE] = { status, hasDecision: app.STATUS === "1", usage: `(${app.USAGE})` }
						})
					})
				}
			} else {
				//console.log(apps,kloUser.currentServerPart )
			}
			resolve(statusObj)
		})
	}

	useEffect(() => {
		setBasketChips(union(appBasket))
		localStorage.setItem('cartApp', JSON.stringify(union(appBasket)))
	}, [appBasket])

	useEffect(() => {
		localStorage.setItem('cartCloud', JSON.stringify(cloudBasket))
	}, [cloudBasket])
	useEffect(() => {
		async function fetchData() {
			let hasKLOFeedback = await axios.post(`${serverAPI}/sendKLORrewiew`, { ci_mkt_id: kloUser.user.CI_MKT_USERS_ID, feedback: kloUser.newFeedBack, user: kloUser.user.FIO });
			_kloUser((prevstate) => { return { ...prevstate, ['hasFeedback']: true } })
			sessionStorage.setItem('hasFeedback', kloUser.newFeedBack);
		}

		if (kloUser.newFeedBack !== undefined && !kloUser.hasFeedback) {
			fetchData();
		}
	}, [kloUser.newFeedBack])



	function handleListItemClick(index, bank) {
		setSelectedIndex(index);
		setBank(bank);
	};

	function scrollMenu() {
		setTimeout(() => {
			if (document.getElementById(window.location.href.split('/')[4]) !== null) {
				document.getElementById(window.location.href.split('/')[4]).scrollIntoView({ block: "end", inline: "nearest", behavior: "smooth" })
			}
		}, 1000);
	}

	function handleDrawer() {
		setOpen(!open);
	};

	function handleExpandClick(ind) {
		expanded === ind && ind !== 0 ? setExpanded(null) : setExpanded(ind);
	};

	const GLOBAL_MEDIA_QUERIES = {
		// small: "(max-width: 599px)",
		medium: "(max-width: 695px)",
		large: "(min-width: 1366px)"
	};

	const handleCloseSnackbar = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		_openSnackbar(false);
		setTimeout(() => { _snackbarMessage(null) }, 1000);
	};

	const handleCloseSnackbarCookies = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		_openSnackbarCookies(false);
		_altCookieSnackbar(false);
		setTimeout(() => { _snackbarMessage(null) }, 1000);
	};

	function setCookie(setAll, confirmBtn) {
		const date = new Date();
		const userMail = usname?.email || '';

		axios.post(`${serverAPI}/saveAgreements`, {
			authUserID: cookiesUID,
			dateGMT: date.toString(),
			required: 1,
			analitycs: setAll ? +setAll : +cookiesAnalitycs,
			marketing: 0,
			allowAll: +setAll,
			confirmBtn: +confirmBtn,
			politicsHash: 'a07007fafe8795d9401631325c9e4f3a99d2b4c2a194245746fe2744fd571d4b' // 2026-08-13
			// politicsHash: '499051927176d26097feb32233ac440715beef57ad9d20cfb20c08bf35f6102e' // 2026-03-20
			// politicsHash: '57f7235407695719bcd7c5d3c4530b40dfb8b02c2522da7ad86aaf7cc6bc3e01' // TODO
			// certutil -hashfile path\to\file\*.pdf SHA256 - генерация SHA-256 Microsoft Windows
		})
			.then(response => {
				if (setAll) {
					_cookiesAnalitycs(true);
				}

				handleCloseSnackbarCookies();
			})
			.catch(error => {
				console.error('ERROR: setCookie', error);
			});
	}

	const showSnackbarMessage = (mess) => {
		_snackbarMessage(<Typography variant="p" className={classes.pCookie}>{mess}</Typography>);
		_openSnackbar(true);
		setTimeout(() => { handleCloseSnackbar() }, 9000);
	}

	const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			const menu = await axios.get(`${serverAPI}/menu/${language}`);
			if (!didCancel) {
				if (menu && menu.data) {
					setMenuItems(menu.data)
					setMenuAppsRenderNew(menu.data)
				}
			}
		}

		fetchData();

		return () => {
			didCancel = true;
		};
	}, [language]);

	useEffect(() => {
		_openSnackbarCookies(altCookieSnackbar);
	}, [altCookieSnackbar])


	// useEffect(() => {
	// 	let didCancel = false;
	// 	async function fetchData() {
	// 		if (!didCancel) {
	// 			let data = utils.getItemFromStorage('showInterview')
	// 			console.log(data, isAuth)
	// 			if (isAuth && data && data.showInterview === true && (+data.date + 3 * 60 * 1000) >= +new Date()) {
	// 				_showInterview(true)
	// 			}
	// 		}
	// 	}

	// 	fetchData();

	// 	return () => {
	// 		didCancel = true;
	// 	};
	// }, [isAuth]);

	function fnv1aHash(str) {  // Получить хеш email авторизованного пользователя для обезличенной идентификации
		const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;  // Проверяем формат строки на соответствие типу email
		let hash = 0x811C9DC5;

		if (!pattern.test(str)) {
			return null;
		}

		for (let i = 0; i < str.length; i++) {
			hash ^= str.charCodeAt(i);
			hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
		}

		return _cookiesUID(hash >>> 0);
	}

	const toggleVisible = (e) => {
		const { scrollTop, scrollHeight } = document.documentElement;

		let footer = document.getElementById('FooterCntr').getBoundingClientRect().height
		//console.log(scrollTop, scrollHeight, footer,window.innerHeight, (scrollTop +window.innerHeight +400) >= (scrollHeight - footer)  )
		if (scrollTop > 1000 /*&& !visible*/) {
			setVisible(true)
		}
		else if (scrollTop <= 1000 /*&& visible*/) {
			setVisible(false)
		}

		let condition = (scrollTop + window.innerHeight + 50) >= (scrollHeight - footer);
		//_showPagination(condition)
		try {
			document.getElementById('paginationContainer-js').style.visibility = !condition ? 'visible' : 'hidden'
			document.getElementById('pagination-js').style.visibility = condition ? 'visible' : 'hidden'
		} catch (e) {
			//console.log(e)
		}

		// if (scrollHeight - scrollTop < 1100 && showPagination === true) {
		// 	console.log("hidePagination", scrollHeight - scrollTop < 1100 && showPagination === true)
		// 	_showPagination(false)
		// } else if (showPagination === false && scrollHeight - scrollTop >= 1100 ){
		// 	console.log("showPagination",!showPagination && scrollHeight - scrollTop >= 1100,!showPagination , scrollHeight - scrollTop >= 1100)
		// 	_showPagination(true)
		// }
	};

	//setTimeout(toggleVisible, 1500)

	const ScrollButton = (props) => {
		const { visible } = props




		// console.log( scrollTop,scrollHeight)


		//window.addEventListener('scroll', toggleVisible);
		if (visible) {
			return (
				<IconButton
					className={classes.toTopBtn}
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					style={{ display: visible ? 'inline' : 'none' }}
					aria-label="Scroll to top"
				>
					<ExpandLessIcon />
				</IconButton>
			);
		} else {
			return null
		}
	}

	// const {scrollTop,scrollHeight} = document.documentElement;
	// try {
	// 	if ( !showPagination &&  (scrollHeight - scrollTop > 1100)){
	// 		_showPagination(true)
	// 	}
	// } catch (e) {
	// 	console.log("mainScrollError")
	// }




	const userCollection = {
		appFavorite,
		appBasket,
		productBasket,
		productFavorite,
		appFavoriteInProduct: appsInProductFavorite
		, appCartInProduct: appsInProductCart
		, inCu, _inCu, setCurrency: () => { let inCu_ = inCu === '1' ? '0' : '1'; localStorage.setItem('inCu', inCu_); _inCu(inCu_); }
		, _CatalogCu //: (cu) => {CatalogCu = cu;console.log("CatalogCu", cu, CatalogCu) }
		, CatalogCu
		, showSnackbarMessage
		, showTestId
	}



	return (
		<div className={classes.root} >
			<CssBaseline />

			<TopBar
				usname={usname}
				setUsname={setUsname}
				isAuth={isAuth}
				setIsAuth={setIsAuth}
				open={open}
				handleDrawer={handleDrawer}
				ml={matches.large}
				handleExpandClick={handleExpandClick}
				badgeBasket={true} // переделать, пусть смотрит на локалсторадж у себя
				setSearchText={setSearchText}
				handleClick={handleClick}
				setFindText={setFindText}
				searchText={searchText}
				searchAction={searchAction}
				setSearchAction={setSearchAction}
				kloUser={kloUser}
				_kloUser={_kloUser}
				_searchPhrases={_searchPhrases}
				userCollection={userCollection}

			/>

			<LeftBar
				key={'_LeftBar'}
				open={open}
				setOpen={setOpen}
				menuAppsRenderNew={menuAppsRenderNew}
				handleDrawer={handleDrawer}
				matches={matches}
				selectedIndex={selectedIndex}
				handleExpandClick={handleExpandClick}
				expanded={expanded}
				handleListItemClick={handleListItemClick}
				menu={menu}
				catalog={catalog}
				setCatalog={setCatalog}
				kloUser={kloUser}
				_kloUser={_kloUser}
				usname={usname}
				setUsname={setUsname}
				isAuth={isAuth}
				setIsAuth={setIsAuth}
			/>


			{/* {
				showInterview
					?
					<Interview showInterview={showInterview} _showInterview={_showInterview} usname={usname} isAuth={isAuth} />
					:
					null
			} */}

			<main
				className={clsx(classes.content, {
					[classes.contentOpen]: open,
					[classes.contentClose]: !open
				})}
			>
				<Container fixed className={classes.Container} id='MainContainer' >
					{
						isSynchronnyLoading
							?
							<CircularProgress className={classes.progress} style={{ width: 100, height: 100 }} />
							:
							null
					}

					{
						!isErr
							?
							<React.Fragment>
								{/* <Grid container direction="row" alignItems="center" style={{ marginBottom: window.location.pathname === '/' ? 16 : undefined }} className={classes.interviewContainer}>
									<Grid item>
										<Typography style={{ color: '#3C3C56', fontWeight: 500, fontSize: '16px', lineHeight: '24px' }}>Мы сможем сделать вашу работу с сайтом максимально комфортной и эффективной. Для этого пройдите опрос.</Typography>
										
									</Grid>
									<Grid item className={classes.cntrReviewBtn}>
										<SecondaryButton height={40} text={"Пройти опрос"} onClick={(e) => {
											e.preventDefault();
											if (isAuth) {
												_showInterview(true)
											} else {
												try {
													let data = JSON.stringify({ showInterview: true, date: +new Date() })
													localStorage.setItem('showInterview', data)
												} catch (e) {

												}
												window.location = `/login?linkTo=${window.location}`
											}
											//_showInterview(true)
										}} />
									</Grid>
								</Grid> */}
								<Switch>
									<Route exact path="/">
										<MainContent
											// setPropsLanguage={setPropsLanguage}
											language={language}
											menuAppsRenderNew={menuAppsRenderNew}
											inCu={inCu}
											userCollection={userCollection}
										/>
									</Route>

									<Route exact path="/survey">
										<Interview
											// setPropsLanguage={setPropsLanguage}
											isAuth={isAuth}
											setErr={_isErr}
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											setAppBasket={setAppBasket}
											selectedIndex={1}
											listNum={listNum}
											open={open}
											IsRu={language === 'Ru'}
											info={bank}
											bank={bank.URL}
											bankname={bank[`Title_${LANG}`]}
											catalog={catalog}
											usname={usname}
											showPagination={showPagination}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											kloUser={kloUser}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route path="/solutions/:bank">
										<SolutionListRouter
											isAuth={isAuth}
											setErr={_isErr}
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											setAppBasket={setAppBasket}
											selectedIndex={1}
											listNum={listNum}
											open={open}
											IsRu={language === 'Ru'}
											info={bank}
											bank={bank.URL}
											bankname={bank[`Title_${LANG}`]}
											catalog={catalog}
											usname={usname}
											showPagination={showPagination}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											kloUser={kloUser}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route path='/products/:bank'>
										<ProdListRouter
											isAuth={isAuth}
											usname={usname}
											setErr={_isErr}
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											setAppBasket={setAppBasket}
											appBasket={appBasket}
											selectedIndex={2}
											listNum={listNum}
											open={open}
											IsRu={language === 'Ru'}
											info={bank}
											bank={bank.URL}
											bankname={bank[`Title_${LANG}`]}
											language={language}
											catalog={catalog}
											showPagination={showPagination}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											kloUser={kloUser}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route exact path='/applications/card/:code'>
										<AppCard
											isAuth={isAuth}
											usname={usname}
											setAppBasket={setAppBasket}
											basketChips={basketChips}
											IsRu={language === 'Ru'}
											type={'applications'}
											catalog={catalog}
											kloUser={kloUser}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											userCollection={userCollection}
											saveCollection={saveCollection}
											handleCloseCookieSnackbar={handleCloseSnackbar}
										/>
									</Route>

									<Route exact path='/applications/apptags'>
										<AppListRouter
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											// setAppBasket={setAppBasket}
											selectedIndex={3}
											// setListNumProps={setListNumProps}
											listNum={listNum}
											open={open}
											language={language}
											bank={bank.URL}
											IsRu={language === 'Ru'}
											setErr={_isErr}
											catalog={catalog}
											apptags={true}
											usname={usname}
											handleCloseCookieSnackbar={handleCloseSnackbar}
											kloUser={kloUser}
											_isSynchronnyLoading={_isSynchronnyLoading}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route path='/applications/:bank'>
										<AppListRouter
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											// setAppBasket={setAppBasket}
											selectedIndex={3}
											// setListNumProps={setListNumProps}
											listNum={listNum}
											open={open}
											language={language}
											bank={bank.URL}
											IsRu={language === 'Ru'}
											setErr={_isErr}
											catalog={catalog}
											usname={usname}
											handleCloseCookieSnackbar={handleCloseSnackbar}
											showPagination={showPagination}
											kloUser={kloUser}
											_isSynchronnyLoading={_isSynchronnyLoading}
											getKloStatuses={getKloStatuses}
											_kloUser={_kloUser}
											searchPhrases={searchPhrases}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route path='/cloud/:bank'>
										<CloudListRouter
											isAuth={isAuth}
											usname={usname}
											setErr={_isErr}
											handleExpandClick={handleExpandClick}
											view={view}
											setAppBasket={setAppBasket}
											setBasketCloud={setBasketCloud}
											basketChips={basketChips}
											appBasket={appBasket}
											open={open}
											language={language}
											IsRu={language === 'Ru'}
											info={bank}
											bank={bank.URL}
											bankname={bank[`Title_${LANG}`]}
											cloudBasket={cloudBasket}
											catalog={catalog}


										/>
									</Route>

									<Route exact path={`/cart`}>
										<BasketContent
											basketChips={basketChips}
											usname={usname}
											setUsname={setUsname}
											isAuth={isAuth}
											setIsAuth={setIsAuth}
											cloudBasket={cloudBasket}
											_appBasket={_appBasket}
											_cloudBasket={_cloudBasket}
											open={open}
											language={language}
											IsRu={language === 'Ru'}
											appBasket={appBasket}
											setAppBasket={setAppBasket}
											setBasketCloud={setBasketCloud}
											menu={menu}
											catalog={catalog}
											handleCloseCookieSnackbar={handleCloseSnackbar}
											kloUser={kloUser}
											_kloUser={_kloUser}
											_isSynchronnyLoading={_isSynchronnyLoading}
											getKloStatuses={getKloStatuses}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route exact path={`/favorites`}>
										<FavoritesContent
											basketChips={basketChips}
											usname={usname}
											setUsname={setUsname}
											isAuth={isAuth}
											setIsAuth={setIsAuth}
											cloudBasket={cloudBasket}
											_appBasket={_appBasket}
											_cloudBasket={_cloudBasket}
											open={open}
											language={language}
											IsRu={language === 'Ru'}
											appBasket={appBasket}
											setAppBasket={setAppBasket}
											setBasketCloud={setBasketCloud}
											menu={menu}
											catalog={catalog}
											handleCloseCookieSnackbar={handleCloseSnackbar}
											kloUser={kloUser}
											_kloUser={_kloUser}
											_isSynchronnyLoading={_isSynchronnyLoading}
											getKloStatuses={getKloStatuses}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route exact path={`/search`}>
										<SearchContent
											setSearchAction={setSearchAction}
											searchAction={searchAction}
											findText={findText}
											menu={menu}
											catalog={catalog}
											usname={usname}
											getKloStatuses={getKloStatuses}
											kloUser={kloUser}
											_kloUser={_kloUser}
											searchPhrases={searchPhrases}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									{/* <Route exact path={`/cookie`}>
										<Cookie />
									</Route> */}
									<Route exact path={`/about`}>
										<About />
									</Route>
									<Route exact path={`/contacts`}>
										<Contacts />
									</Route>

									<Route path="/partners/:bank">
										<PartnersListRouter
											setErr={_isErr}
											handleExpandClick={handleExpandClick}
											basketChips={basketChips}
											setAppBasket={setAppBasket}
											selectedIndex={5}
											listNum={listNum}
											open={open}
											IsRu={language === 'Ru'}
											info={bank}
											bank={bank.URL}
											bankname={bank[`Title_${LANG}`]}
											catalog={catalog}
											userCollection={userCollection}
											saveCollection={saveCollection}
										/>
									</Route>

									<Route>
										<PageNotFound open={open} IsRu={language === 'Ru'} />
									</Route>
								</Switch>
							</React.Fragment>
							:
							<PageNotFound open={open} IsRu={language === 'Ru'} />
					}

					<SnackbarCookies
						language={language}
						openSnackbar={openSnackbarCookies}
						snackbarMessage={snackbarMessage}
						cookieMessage={cookieMessage}
						_cookies1={_cookies1}
						_cookies2={_cookies2}
						setCookie={(val1, val2) => setCookie(val1, val2)}
						handleCloseSnackbar={() => handleCloseSnackbarCookies()}
						cookies1={cookies1}
						cookies2={cookies2}
						cookiesAnalitycs={cookiesAnalitycs}
						_cookiesAnalitycs={_cookiesAnalitycs}
						altCookieSnackbar={altCookieSnackbar}
						_altCookieSnackbar={_altCookieSnackbar}
					/>

					<Snackbar
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						open={openSnackbar}
						className={classes.snackbarRoot}
					>
						<div className={classes.snackbarPostroot}>
							{snackbarMessage}

							<Grid item style={{ width: 16 }} />

							<PrimaryButton text={"OK"} height={55} onClick={() => { if (snackbarMessage === null) { setCookie() } else { handleCloseSnackbar() } }} />

							<Grid item style={{ width: 36 }} />
						</div>
					</Snackbar>

					<ScrollButton visible={visible} />

					<Footer
						openSnackbar={openSnackbarCookies}
						_openSnackbar={_openSnackbarCookies}
						_altCookieSnackbar={_altCookieSnackbar}
					/>

					<button style={{ display: 'none' }} onClick={() => console.warn(isMetrikaActive)}>
						Проверить Метрику
					</button>

					{testID ? <Grid id='test-data-ready' style={{ visibility: 'hidden' }}></Grid> : null}
				</Container>
			</main>
		</div>
	);
}

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex'
	},

	content: {
		flexGrow: 1,
		padding: 0,
		//paddingTop: 28,
		marginTop: 108,

		[theme.breakpoints.down(1367)]: {
			marginTop: 96
		},

		[theme.breakpoints.down(696)]: {
			marginTop: 96
		},
		[theme.breakpoints.down(440)]: {
			marginTop: 160
		},
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	Container: {
		padding: 0,

		[theme.breakpoints.only('xl')]: {
			maxWidth: 1320
		},

		[theme.breakpoints.between('md', 'lg')]: {
			maxWidth: 984
		},

		[theme.breakpoints.only('sm')]: {
			maxWidth: 651
		},

		[theme.breakpoints.only('xs')]: {
			maxWidth: 312
		},

		[theme.breakpoints.down(360)]: {
			maxWidth: 312
		},
	},

	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
	},

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		marginBottom: 17,
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},

	LinkType11: {
		color: 'inherit',
		textDecoration: 'none',
		borderBottom: '1px solid',
		borderColor: 'inherit',

		'&:hover': {
			color: '#86B6FF',
			textDecoration: 'none',
			borderBottom: '1px solid #86B6FF',
		}
	},

	snackbarPostroot: {
		padding: 24,
		alignItems: 'center',
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		boxSizing: 'borderBox',
	},

	toTopBtn: {
		position: 'fixed',
		fontSize: '20px',
		bottom: '30px',
		right: '61px',
		backgroundColor: '#FFF',
		color: '#8987A2',
		textAlign: 'center',

		'&:hover': {
			backgroundColor: '#5D75F8',
			color: '#FFF'
		},

		[theme.breakpoints.down(550)]: {
			right: '15px',
		},
	},

	interviewContainer: {
		justifyContent: "space-between",
		display: 'flex',
		backgroundColor: '#FFE6C9',
		borderRadius: '16px',
		padding: '14px 24px 14px 32px',
		// marginBottom:16
		// lineHeight: 24,

	},
	interviewHeadreLink: {
		fontSize: 16,
		color: '#8987A2',
		marginLeft: 8,
		textDecoration: 'underline',
		// lineHeight: '18px',
		cursor: 'pointer'
	},

	cntrReviewBtn: {
		[theme.breakpoints.down('lg')]: {
			marginTop: 24
		},
	},
	progress: {
		position: 'fixed',
		color: '#3C3C56',
		width: 50,
		height: 50,
		top: '50%',
		left: '50%',
		right: '1%',
		bottom: '1%',
		zIndex: 1500,
	},

	pCookie: {
		maxWidth: 818,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '28px',
		color: '#FFFFFF',
	}
}));
